import { getCurrentBranchName } from 'app/branches/selectors';
import { getCurrentProjectId } from 'app/project/selectors';
import { useSelector } from 'react-redux';
import { type LinkHookProps, useLink } from '../link/link-hook.js';

export type ProjectLinkHookProps = Omit<LinkHookProps, 'projectId' | 'branchName'>;

export const useProjectLink = (props: ProjectLinkHookProps) => {
  const projectId = useSelector(getCurrentProjectId);
  const branchName = useSelector(getCurrentBranchName);
  return useLink({ projectId, branchName, ...props });
};
